import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { UserDefinitionService } from '@services/user-definition.service';
import { map } from 'rxjs';

const SUPPLIER_ADMIN_ALLOWED_ROUTES = ['/', '/flights', '/reservations'];

export const supplierAdminGuard: CanActivateChildFn = (route, state) => {
    const userDefinitionService = inject(UserDefinitionService);
    const router = inject(Router);

    return userDefinitionService.getUserInfo().pipe(
        map(() => {
            if (!userDefinitionService.isSupplierAdmin()) {
                return true;
            }

            if (SUPPLIER_ADMIN_ALLOWED_ROUTES.includes(state.url)) {
                return true;
            }

            return router.createUrlTree(['/not-authorized']);
        })
    );
};
